<template>
    <div id="mydataadd">
        <el-form v-show="layerType == 'add'" ref="form" style="border-top: 1px solid rgb(242, 242, 242);" :model="form"
            label-width="100px" :rules="rules">
            <el-form-item v-if="mydata.pathtype != '/data'" label="上级目录" prop="suppath">
                <el-select style="width: 100%;" v-model="form.suppath" placeholder="请选择">
                    <el-option v-for="item in pathlist" :key="item.name" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-else label="上级目录" prop="suppath">
                <el-input disabled v-model="form.suppath"></el-input>
            </el-form-item>
            <el-form-item label="目录别名" prop="name" v-if="mydata.pathtype != '/data'">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="目录名称" prop="path">
                <el-input v-model="form.path"></el-input>
            </el-form-item>
        </el-form>
        <el-image :src="viewsrc" v-if="layerType == 'viewpic'"
            style="display:flex;justify-content: center;align-items: center;"></el-image>
        <video style="width: 100%;height: 300px;" :src="viewsrc" v-if="layerType == 'viewvideo'" controls></video>
        <div v-show="layerType == '/pic' || layerType == '/video' || layerType == '/data'">
            <div style="padding-right:80px;margin-top:10px;margin-bottom:10px;">
                <label>当前目录：</label>
                <el-select style="width: 100%;" v-model="upfupath" placeholder="请选择">
                    <el-option v-for="item in pathlist" :key="item.name" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <el-upload class="upload-demo" action="#" :show-file-list="false" :auto-upload="false"
                :on-change="handlePreview">
                <div>
                    <span v-show="layerType == '/pic'">只能上传图片格式:jpeg,jpg,png,gif,bmp文件 &nbsp;</span>
                    <span v-show="layerType == '/video'">只能上传视频格式:avi,mp4,mov,mkv文件 &nbsp;</span>
                    <el-button size="small" type="primary">点击上传</el-button>
                </div>
            </el-upload>
            <div style="height:100px">
                <div v-for="(item, index) in fileList" :key="index">
                    <i class="el-icon-document"></i>
                    {{ item.name }}
                    <i style="color:#72C648;float:right" class="el-icon-circle-check"></i>
                </div>
            </div>
        </div>
        <div class="toos_layer_footer" style="padding:5px;">
            <el-button type="primary" @click="submit">确定</el-button>
            <el-button type="primary" @click="cancel" v-show="layerType != '/pic' || layerType != '/video'">取消</el-button>
        </div>
    </div>
</template>
<script>
export default {
    props: [
        "dialogFormVisibles",
        "layerType",
        "loadTable",
        "loadTable1",
        'mydata',
    ],
    data() {
        return {
            rules: {
                name: [
                    { required: true, message: "请输入目录别名", trigger: "blur" },
                ],
                path: [
                    { required: true, message: "请输入目录名称", trigger: "blur" },
                    { pattern: /^[a-zA-Z0-9]+$/, message: '请填写正确的目录名称可以包含数字字母', trigger: 'blur' }
                ],
            },
            form: {
                path: "",
                name: "",
                suppath: '',
            },
            viewsrc: '',
            pathlist: [],
            fileList: [],
            upfupath: '',
            option1: [],
            option2: [],
        };
    },
    mounted() {
        if (this.layerType == 'viewpic') {
            this.loadImage(this.mydata);
        } else if (this.layerType == 'viewvideo') {
            this.viewsrc = this.mydata
        } else if (this.layerType == 'add') {
            if (this.mydata.pathtype == '/data') {
                this.form.suppath = this.mydata.path
            } else {
                this.fileslist(this.mydata.pathtype)
            }

        } else if (this.layerType == '/pic' || this.layerType == '/video') {
            this.bycodelist('DM-IMG-TPSCGS', 1)
            this.bycodelist('DM-VIDEO-SPSCGS', 2)
            this.fileslist(this.layerType)
        }
    },
    methods: {
        removeTrailingSlash(str) {
            if (str.endsWith('/')) {
                return str.substring(0, str.length - 1);
            } else {
                return str;
            }
        },
        loadImage(url) {
            const img = new Image();
            img.onload = () => {
                this.viewsrc = url;
            };
            img.onerror = () => {
                this.handleImageError();
            };
            img.src = url;
        },
        handleImageError() {
            this.viewsrc = require('@/assets/loadimage_failed.png');
        },
        bycodelist(code, type) {
            this.$tools
                .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
                    data: {
                        "dictionary_code": code
                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        var str = []
                        res.data.data.dictionary_detail.forEach(element => {
                            str.push(element.dictionary_key)
                        });
                        switch (type) {
                            case 1:
                                this.option1 = str
                                break;
                            case 2:
                                this.option2 = str
                                break;
                            default:
                                break;
                        }
                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch((err) => {
                })
        },
        handlePreview(file) {
            if (this.option1.includes(file.raw.type)) {
                var formdata = new FormData()
                formdata.append('file', file.raw);
                formdata.append('rename', '1');
                this.upload(formdata).then((res) => {
                    if (res.filename.length > 50) {
                        res.filename = res.filename.slice(0, 20) + '...' + res.filename.slice(res.filename.indexOf('.') - 20, res.filename.length);
                    }
                    this.fileList.push({
                        name: res.filename,
                    })
                    if (this.fileList.length > 2) {
                        this.fileList = this.fileList.slice(-3)
                    }
                })
            } else if (this.option2.includes(file.raw.type)) {
                var formdata = new FormData()
                formdata.append('file', file.raw);
                formdata.append('rename', '1');
                this.upload(formdata).then((res) => {
                    if (res.filename.length > 50) {
                        res.filename = res.filename.slice(0, 20) + '...' + res.filename.slice(res.filename.indexOf('.') - 20, res.filename.length);
                    }
                    this.fileList.push({
                        name: res.filename,
                    })
                    if (this.fileList.length > 2) {
                        this.fileList = this.fileList.slice(-3)
                    }
                })
            } else if (this.layerType == '/data') {
                var formdata = new FormData()
                formdata.append('file', file.raw);
                formdata.append('rename', '1');
                this.upload(formdata).then((res) => {
                    if (res.filename.length > 50) {
                        res.filename = res.filename.slice(0, 20) + '...' + res.filename.slice(res.filename.indexOf('.') - 20, res.filename.length);
                    }
                    this.fileList.push({
                        name: res.filename,
                    })
                    if (this.fileList.length > 2) {
                        this.fileList = this.fileList.slice(-3)
                    }
                })
            } else {
                if (this.layerType == '/pic') {
                    this.$message({
                        type: "error",
                        message: '上传的图片格式不对',
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '上传的视频格式不对',
                    });
                }
            }
        },
        fileslist(path) {
            this.$tools
                .asyncPost(this, this.$baseUrl.fileseplist, {
                    data: {
                        bucket: localStorage.getItem('enterprise_id'),
                        path: path
                    }
                })
                .then((res) => {
                    if (res.data.code == 0) {
                        if (res.data.data.length != 0) {
                            this.form.suppath = this.mydata.id
                            this.upfupath = this.mydata.name
                        }
                        this.pathlist = res.data.data
                    } else {
                        this.$message({
                            type: "error",
                            message: res.data.msg,
                        });
                    }
                })
        },
        submit() {
            if (this.layerType == 'add') {
                if (this.mydata.pathtype == '/data') {
                    if (this.form.path.includes('/data/') == false) {
                        if (this.form.suppath != '' && this.form.suppath != undefined && this.form.suppath != null) {
                            this.form.path = this.mydata.path + this.form.path
                        } else {
                            this.form.path = '/data/' + this.form.path
                        }
                    }
                }
                if (this.mydata.pathtype == '/pic') {
                    if (this.form.path.includes('/pic/') == false) {
                        if (this.form.suppath != '' && this.form.suppath != undefined && this.form.suppath != null) {
                            this.form.path = this.mydata.path + '/' + this.form.path
                        } else {
                            this.form.path = '/pic/' + this.form.path
                        }
                    }
                }
                if (this.mydata.pathtype == '/video') {
                    if (this.form.path.includes('/video/') == false) {
                        if (this.form.suppath != '' && this.form.suppath != undefined && this.form.suppath != null) {
                            this.form.path = this.mydata.path + '/' + this.form.path
                        } else {
                            this.form.path = '/video/' + this.form.path
                        }
                    }
                }
                if (this.mydata.pathtype == '/data') {
                    this.$tools
                        .asyncPost(
                            this,
                            this.$baseUrl.filesmkdir, {
                            data: {
                                bucket: localStorage.getItem("enterprise_id"),
                                parent: this.form.suppath,
                                path: this.form.path,
                                name: this.form.name,
                            },
                        })
                        .then((res) => {
                            if (res.data.code == 0) {
                                this.$message({
                                    type: "success",
                                    message: '添加成功',
                                });
                                this.dialogFormVisibles.val = false;
                                this.$emit('loadTable1', '')
                            } else {
                                this.$message({ type: "error", message: res.data.msg });
                            }
                        })
                } else {
                    this.$tools
                        .asyncPost(
                            this,
                            this.$baseUrl.filesepadd, {
                            data: {
                                bucket: localStorage.getItem("enterprise_id"),
                                parent: this.form.suppath,
                                path: this.form.path,
                                name: this.form.name,
                            },
                        })
                        .then((res) => {
                            if (res.data.code == 0) {
                                this.$message({
                                    type: "success",
                                    message: '添加成功',
                                });
                                this.dialogFormVisibles.val = false;
                                this.$emit('loadTable')
                            } else {
                                this.$message({ type: "error", message: res.data.msg });
                            }
                        })
                }



            } else {
                this.dialogFormVisibles.val = false;
                this.$emit('loadTable')
            }
        },
        async upload(formdata) {
            try {
                const res = await this.$axios.post(this.$baseUrl.filesupload + '/' + localStorage.getItem('enterprise_id') + this.mydata.path, formdata, {
                    headers: {
                        'token': localStorage.getItem("token"),
                        'content-type': 'multipart/form-data'
                    }
                });
                if (res.data.code == 0) {
                    return res.data.data[res.data.data.length - 1];
                } else {
                    this.$message({ type: "error", message: res.data.msg })
                }
            } catch (err) {
                // this.$message({ type: "error", message: err });
            }
        },
        cancel() {
            this.dialogFormVisibles.val = false;
        },
    },

};
</script>